import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, Radio, RadioGroup, TextField, Grid } from '@mui/material'
import React, { useState } from 'react'
import { MenuIcon } from '../../../../../core/icon/__refactored/Icon'
import { useEffect } from 'react'
import { rqx } from '../../../../../core/request/API'
import { env } from '../../../../../core/Env'
import { SnakeLoader } from '../../../../../core/loader/SnakeLoader'
import { FeatureIdState } from '../../../toolUsage/global/GlobalFcn'
import { CreateFeatureLogs } from '../../../../../core/request/Global'

export const PostEval = ({openWidth, wideHandler, information_state, uid, nav, info, tool_state}) => {
    const [ans, setAns] = useState([])
    const [act, setAct] = useState(false)
    const [selectCategory, setselectCategory] = useState([])
    // eslint-disable-next-line
    const [correctAnswers, setCorrectAnswers] = useState(0);
    const [validationError, setValidationError] = useState('');
    let urlParams = new URLSearchParams(window.location.search);
    
    useEffect( () => {
        information_state.test.set({...information_state.test.data, name:'Post Evaluation'})
        const __init = async()=> {
            const init = await rqx.get(`<<tool>>/${env()}/biz_exam/user_read_PostEvaluation`, {training_id:urlParams.get('id'), ref:'trainings'})
            information_state.exam.set(init)
            const progress = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_check_trainings`, {training_id:urlParams.get('id'), user_id: uid, ref:'trainings', company_id: tool_state.cinfo.data[0].company_id })
            const tContent = await rqx.get(`<<tool>>/${env()}/biz_trainings/user_training_content`, {training_id:urlParams.get('id'), ref:'trainings', company_id: tool_state.cinfo.data[0].company_id})
            const updatedProg = { pretest: 1, vl: 1, quiz: 1, posteval: 0 };
            progress.forEach(item => {
                if (item.exam_type === 1) {
                // pretest
                updatedProg.pretest = item.exam_type === 1 ? 1 : 0;
                } else if (item.exam_type === 2) {
                // quiz
                updatedProg.quiz = item.exam_type === 2 ? 1 : 0;
                } else if (item.exam_type === 3) {
                // post eval
                updatedProg.posteval = item.exam_type === 3 ? 1 : 0;
                } else if (item.exam_type === 4) {
                // video Lesson
                updatedProg.vl = item.exam_type === 4 ? 1 : 0;
                }
            });
            information_state.prog.set(updatedProg)
            information_state.tc.set({...information_state.tc.data, pretest:tContent[0].pretest_id !== null ? 1 : null, quiz:tContent[0].quiz_id !== null? 1: null, posteval:tContent[0].post_evaluation_id !== null ? 1 : null})
        }
        __init()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleChange =(e, id, question, k) => {
        const userAnswer = e.target.value.trim();
        const answerStatus = userAnswer !== '' ? 1 : 0;
        let newAns = [...ans];
        newAns[k] = { question_id: id, question: question, ans: e.target.value, answer_status: answerStatus };
        setAns(newAns);

        let newSelectCategory = [...selectCategory];
        newSelectCategory[k] = k;
        setselectCategory(newSelectCategory);

        let err = [...validationError]
        err[k] = false
        setValidationError(err)
        if (!newAns[k]) {
            setCorrectAnswers((prevCount) => prevCount + 1);
        }
    }

    const handleRadioChange = (event, question_id, question, k) => {
        const userAnswer = event.target.value;
        const answerStatus = userAnswer !== '' ? 1 : 0;
        let newAns = [...ans];
        newAns[k] = { question_id: question_id, question: question, ans: userAnswer, answer_status: answerStatus };
        setAns(newAns);
    
        let newSelectCategory = [...selectCategory];
        newSelectCategory[k] = k;
        setselectCategory(newSelectCategory);
    
        let err = [...validationError];
        err[k] = false;
        setValidationError(err);
      };

    const handleSubmit = () => {
        const correctCount = ans.filter(a => a && a.answer_status === 1).length;
        setCorrectAnswers(correctCount);
        
        const allAnsweredStatus = information_state.exam.data.exam.map((q, k) => {
            if (ans[k] && ans[k].ans !== '') {
                return false;
            } else {
                return true;
            }
        });
        
        if (allAnsweredStatus.includes(true)) {
            setValidationError(allAnsweredStatus);
            return;
        } else {
            setValidationError(allAnsweredStatus);
        }
        
        const data ={
          user_id:uid,
          exam_type:3,
          progress_status:1,
          training_id:urlParams.get('id'),
          data:ans,
          company_id: tool_state.cinfo.data[0].company_id
        }
        _init(data)
        
    }
    
    const _init = async(data)=>{
        // eslint-disable-next-line
        let res = { 
            aid: tool_state.__SESSION.data.ainfo.aid,
            path: `${FeatureIdState('assessment')}->3`,
            feature_id: FeatureIdState('assessment'),
            feature_name: 'assessment-post-evaluation',
            tid: parseInt(process.env.REACT_APP_TID_BIZ),
            company_id: tool_state.cinfo.data[0].company_id,
            action: 1,
        } 
        await CreateFeatureLogs(res)
        await rqx.post(`<<tool>>/${env()}/biz_exam/user_update_status`, data)
        const init = await rqx.post(`<<tool>>/${env()}/biz_exam/exam_create`, data)
        if (init.message === 'success' || init.message === 'proceed') {
            openWidth.set(!openWidth.data);
            setAct(true)
        }
    }

    const handleComplete = async() => {
        let data = {
            user_id:uid,
            training_id:urlParams.get('id'),
            ref: 'training',
            company_id: tool_state.cinfo.data[0].company_id,
            profession_id:tool_state.pData.data.profession
        }
        const comp = await rqx.post(`<<tool>>/${env()}/biz_exam/exam_update_EOC`, data)
        if (comp.message === 'success'){
            const cert = await rqx.get(`<<tool>>/${env()}/biz_exam/user_certificate`, data)
            info.set({...info.data, detailed:cert[0] , preview: {...cert[0], tab: 'academy'}})
            nav.push('/biz/certificates/academy')
        }
    }

    const handleCheckboxChange = (question_id, question, k, choiceKey, checked) => {
        // clone the current ans array
        const updated = [...ans];

        // initialize the question entry if it doesn't exist
        if (!updated[k]) {
            updated[k] = {
                question_id,
                question,
                ans: [],
                answer_status: 0
            };
        }

        // clone current answers array for this question
        const current = Array.isArray(updated[k].ans) ? [...updated[k].ans] : [];

        // add or remove the choice
        if (checked) {
            if (!current.includes(choiceKey)) current.push(choiceKey);
        } else {
            const index = current.indexOf(choiceKey);
            if (index > -1) current.splice(index, 1);
        }

        // update the question entry
        updated[k] = {
            question_id,
            question,
            ans: current,
            answer_status: current.length > 0 ? 1 : 0
        };

        // set state
        setAns(updated);

        // clear validation error
        const err = [...validationError];
        err[k] = false;
        setValidationError(err);
    };

    return (
        <Box p="40px" display="flex" flexDirection="column" width="100%" height="100%">
            <Box width="100%" height="100%">
                
                { act === false ? (
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box fontSize={14} fontWeight={400} lineHeight="22.65px">Direction: Input and Choose the letter of the correct answer.</Box>
                        { !openWidth.data && (
                            <Box display="flex" className='c-pointer' onClick={wideHandler}>
                                <MenuIcon />
                                <Box fontSize={14} fontWeight={600} lineHeight="22.65px" color="#1893F1" ml="12px">Show menu</Box>
                            </Box>
                            )
                        }
                    </Box>
                ) : (
                    <>
                        <Box border="1px solid #E5EBF6" bgcolor="#F5F8FF" borderRadius="8px" p="24px" my="24px" width="100%">
                            <Box display="flex" flexDirection="column" alignItems="center">
                                <Box fontSize="P-600" lineHeight="23px" color="#313131" fontWeight={600}>Congratulations!</Box>
                                <Box fontSize="P-300" lineHeight="23px" color="#313131" mt="24px" >You can now download your copy of E-Certificate. Thank you for allowing us to be part of your learning journey.</Box>
                            </Box>
                        </Box>
                        <Box display="flex" flexDirection="column" alignItems="center">
                            <Box fontSize="P-300" lineHeight="23px" color="#1893F1">Mark it as complete and generate your certificate!</Box>
                        </Box>
                    </>
                )}
                { act === false && (
                    information_state.exam.data !== undefined ? (
                        information_state.exam.data.exam.map((q, k) => (
                            <Box key={k} border="1px solid #E5EBF6" borderRadius="6px" p="24px" mt="24px" width="100%">
                                {console.log(q)}
                                <Box fontSize="P-400" fontWeight={600} lineHeight="22px">Question no. {k + 1}</Box>
                                <Box fontSize="P-300" fontWeight={400} lineHeight="22px" mt="24px" mb="8px">{q.question}</Box>
                                {
                                    q.type === 2 ? (
                                        <Box component={TextField} multiline  maxRows={4} borderColor="#E5EBF6" bgcolor="#F5F8FF" width="100%" mt="16px" onChange={(e)=>handleChange(e, q.question_id, q.question, k)} value={ans[k]?.ans || ''} error={validationError[k]} >{q.question}</Box>
                                    ) : q.type === 3 ? (
                                        <>
                                            <Box my={4}>
                                                <RadioGroup name="Linear Scale" value={ans[k]?.ans} onChange={(e) => handleRadioChange(e, q.question_id, q.question, k)}>
                                                    {[1,2,3,4].map((num, i) => (
                                                        <FormControlLabel key={i} value={num} control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 28, }, }} />}
                                                            label={
                                                                <Box display="flex" alignItems="center">
                                                                    <Box mx={2} width="15px">
                                                                        <Box fontSize={16} color="#333333">{num}</Box>
                                                                    </Box>
                                                                    <TextField value={q.choices[i]?.value} name="choices"
                                                                        InputProps={{
                                                                            sx: { minHeight: "40px", bgcolor: "#fff" },
                                                                            readOnly: true,
                                                                        }} variant="outlined" size="small" 
                                                                    />
                                                                </Box>
                                                            }
                                                        />
                                                    ))}
                                                </RadioGroup>
                                                {validationError[k] === true && (<FormHelperText sx={{color:"red"}}>*Please select an option.</FormHelperText>)}
                                            </Box>
                                        </>
                                    ) : q.type === 5 && (
                                        <>
                                            <Box my={4}>
                                                <FormControl>
                                                    <FormGroup>
                                                        <Grid container spacing={2}>
                                                            {q.choices.map((choice, cIndex) => (
                                                                <Grid key={cIndex} item xs={12}>
                                                                    {console.log(choice)}
                                                                    {console.log(ans[k])}
                                                                    <Box display="flex" alignItems="center" width="100%">
                                                                    <Checkbox
                                                                        checked={ans[k]?.ans?.includes(choice.key) || false}
                                                                        onChange={(e) =>
                                                                            handleCheckboxChange(
                                                                                q.question_id,
                                                                                q.question,
                                                                                k,
                                                                                choice.key,
                                                                                e.target.checked
                                                                            )
                                                                        }
                                                                    />
    
                                                                    <TextField
                                                                        value={choice.value}
                                                                        InputProps={{
                                                                        sx: { minHeight: "40px", bgcolor: "#fff" },
                                                                        readOnly: true,
                                                                        }}
                                                                        variant="outlined"
                                                                        size="small"
                                                                        fullWidth
                                                                    />
                                                                    </Box>
                                                                </Grid>
                                                            ))}
                                                        </Grid>
                                                    </FormGroup>
    
                                                    {validationError[k] === true && (
                                                        <FormHelperText sx={{ color: "red" }}> *Please select at least one option. </FormHelperText> 
                                                    )}
                                                </FormControl>
                                            </Box>
                                        </>
                                    )
                                }
                            </Box>
                        ))
                    ) : (
                        <Box display="flex" justifyContent="center">
                            <SnakeLoader size="0.7rem" bg="#0170EC" distance="0.3rem" />
                        </Box>
                    )
                )}
                <Box display="flex" justifyContent={act === false ? "flex-end" : "center" } my="24px">
                    {
                        act === false ? (
                            <Box component={Button} onClick={(e) => handleSubmit(e)} variant='contained'>Submit</Box>
                        ) : (
                            <Box component={Button} onClick={(e) => handleComplete(e)} variant='contained'>Complete</Box>
                        )
                    }
                </Box>
            </Box>
        </Box>
    )
}